import React, { CSSProperties, FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { RecentlyViewedItem } from '../../../../../../../generated/graphql';
import { IListingItemProps } from '../product-listing-component';
import sharedStyles from '../shared/listing-item-component.module.scss';
import styles from './category-listing-item-component.module.scss';

export type CategoryListingItemProps = IListingItemProps<RecentlyViewedItem>;

export const CategoryListingItem: FunctionComponent<CategoryListingItemProps> = (props: CategoryListingItemProps) => {
  return (
    <div
      className={`${sharedStyles['listing-item-container']} ${styles['listing-item-container']}`}
      style={{ '--tablet-width': props.tabletWidth ?? 'fit-content' } as CSSProperties}>
      <Link to={props.item.url.url} onClick={onClick} className={styles.title}>
        {props.item.url.text}
      </Link>
      <Link to={props.item.url.url} onClick={onClick}>
        <img className={sharedStyles.image} src={props.item.imageUrl ?? ''} alt={props.item.url.text}></img>
      </Link>
    </div>
  );

  function onClick() {
    props.onClickCallback && props.onClickCallback(props.item);
  }
};
